import { IsBoolean, IsOptional, IsString, ValidateNested } from "class-validator";
import { Expose, Type } from "class-transformer";

export class OrderDocumentListItem {
  @IsString()
  @Expose()
  id!: string;
  @IsString()
  @Expose()
  documentNumber!: string;
  @IsString()
  @Expose()
  documentTypeName!: string; // "Faktura VAT";
  @IsOptional()
  @IsString()
  @Expose()
  layout!: null | string; // null, Standard, Extended
  @IsString()
  @Expose()
  translationCulture!: string;
  @IsString()
  @Expose()
  saleDate!: string;
  @IsString()
  @Expose()
  issueDate!: string;
  @IsBoolean()
  @Expose()
  receiptHasInvoice!: boolean;
  @IsBoolean()
  @Expose()
  canReprintDocument!: boolean;
  @IsBoolean()
  @Expose()
  canGenerateXMLFile!: boolean;
}

export default OrderDocumentListItem;

export class OrderDocumentResponse {
  @Type(() => OrderDocumentListItem)
  @ValidateNested()
  @Expose()
  items!: Array<OrderDocumentListItem>;
  @IsBoolean()
  @Expose()
  generateDocumentsEnabled!: boolean;
  @IsBoolean()
  @Expose()
  generateProformaEnabled!: boolean;
}
